import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import homeImg from '../../assets/illustrations/LandingPage/home.png';
import loginImg from '../../assets/illustrations/LandingPage/login.png';

const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-[#4f2f1e] backdrop-blur-sm py-3 md:py-4 shadow-lg' 
          : 'bg-transparent py-4 md:py-8'
      }`}
      role="navigation"
      aria-label="Navegação principal"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          {/* Logo no canto esquerdo */}
          <button 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center group"
            aria-label="Voltar ao topo"
          >
            <div className="w-10 h-10 md:w-16 md:h-16 rounded-full flex items-center justify-center">
              <img 
                src={homeImg} 
                alt="Mulheres que Correm com os Lobos - Background" 
                className="w-full h-full object-cover animate-ken-burns"
              />
            </div>
          </button>



          {/* Ícone de perfil no canto direito */}
          <button 
            onClick={() => navigate('/login')}
            className="flex items-center group"
            aria-label="Fazer login ou acessar perfil"
          >
            <div className="w-10 h-10 md:w-16 md:h-16 rounded-full flex items-center justify-center">
              <img 
                src={loginImg} 
                alt="Mulheres que Correm com os Lobos - Background" 
                className="w-full h-full object-cover animate-ken-burns"
              />
            </div>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;